import { NetworkStatus } from '@cbridge-utils/network';
import { IMarkupProfileStore } from './markupProfile.interface';

export const markupProfileInitialState: IMarkupProfileStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
